import gql from 'graphql-tag';

export const LoomAuthTokenQuery = gql`
	query LoomAuthTokenQuery {
		loomToken {
			token
		}
	}
`;
